module.exports = __webpack_public_path__ + "media/6.d60e0736.mp3";